import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');
import { SalaryRule } from './SalaryRule';

export class MainSalary extends SalaryRule {
    _originalTypeClassName = "zERP.BO.MainSalary";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MainSalary.translate = translateService;
}
super();
this.EmployeeStamp = null;
this.EmployerStamp = null;
this.OGAEmployeeStamp = null;
this.OGAEmployerStamp = null;
this.IsRegular = false;
this.IsNegative = false;
this.DailySalarySum = false;
this.UseIncreasedDailySalary = false;
this.ParticipatesInProvisions = false;
this.ParticipatesDeductionEE = false;
this.ParticipatesPlafonIKA = false;
this.ParameterType = null;
this.ParameterMultiplier = 1;
this.InsuranceDailySalaryCalculationMethod = null;
this.IsCalculatedOnBasic = false;
this.InsuranceDailySalaryMultiplier = null;
this.KaeCode = null;
this.EapCode = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
EmployeeStamp:any;
EmployerStamp:any;
OGAEmployeeStamp:any;
OGAEmployerStamp:any;
IsRegular:any;
IsNegative:any;
DailySalarySum:any;
UseIncreasedDailySalary:any;
ParticipatesInProvisions:any;
ParticipatesDeductionEE:any;
ParticipatesPlafonIKA:any;
ParameterType:any;
ParameterMultiplier:any;
InsuranceDailySalaryCalculationMethod:any;
IsCalculatedOnBasic:any;
InsuranceDailySalaryMultiplier:any;
KaeCode:any;
EapCode:any;
DailySalaryExpression:any;
static setDailySalaryExpression = ($this, value) => {
var oldValue = $this.DailySalaryExpression;
$this.DailySalaryExpression = value;
if (value != null) {
}
}

static GetClassName(): any{return CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}